import { head, isEmpty, lowerCase } from 'lodash/fp';

import { BrandCampaign, Maybe, MemberPerk } from '../../../../../types/__codegen__/sanity/graphql';
import { CONTENT_SECTIONS } from '../../../content/sections';
import { PRODUCT_REVIEW_IDS } from '../../../constants';
import getImageAttributes from '../../../../../cms/utils/get-image-attributes';
import mapOffer from '../map-offer';
import type { BrandCampaignType, SectionBrandCampaignType } from '../../../types';

type MapHeaderContentProps = {
  cmsSectionContent: Maybe<Maybe<BrandCampaign>[]> | undefined;
  insuranceType?: Maybe<string> | undefined;
  offerData?: MemberPerk[] | undefined;
};

type ProductReviewIdKeys = keyof typeof PRODUCT_REVIEW_IDS;

const mapHeaderContent = ({ cmsSectionContent, insuranceType, offerData }: MapHeaderContentProps) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }
  const brandCampaign = head(cmsSectionContent) as BrandCampaignType;
  const productReviewId = insuranceType ? PRODUCT_REVIEW_IDS[lowerCase(insuranceType) as ProductReviewIdKeys] : null;
  const showProductReviewWidget = !!productReviewId;
  const offer = mapOffer({ cmsSectionContent: offerData });

  const mappedCmsContent: SectionBrandCampaignType = {
    cta: {
      title: brandCampaign?.urlObject?.name,
      to: brandCampaign?.urlObject?.url,
    },
    hasProductReviewWidget: showProductReviewWidget,
    image: getImageAttributes({ height: 480, imageObject: brandCampaign.imageObject }),
    offer,
    subtitle: brandCampaign?.descriptionRaw,
    title: brandCampaign?.sloganRaw,
    type: CONTENT_SECTIONS.HEADER,
  };

  return mappedCmsContent;
};

export default mapHeaderContent;
